import { Component } from 'react';

import { graphql, withApollo } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import compose from 'lodash.flowright';
import PropTypes from 'prop-types';

import TraceCard, {
  fragments as traceCardFragments
} from '@/components/traceCard/traceCard';
import TraceIconSpinner from '@/components/ui/traceIconSpinner';
import { FILTERS_QUERY } from '@/gql/localQueries';

export class StageTraces extends Component {
  static propTypes = {
    filtersQuery: PropTypes.object.isRequired,
    groupId: PropTypes.string.isRequired,
    stageQuery: PropTypes.object.isRequired
  };

  subscribeToStage(props) {
    const { stageQuery, stageId } = props;
    this.unsubscribeFromStage = stageQuery.subscribeToMore({
      document: subscriptions.stage,
      variables: { id: `stage:${stageId}` },
      updateQuery: (_prev, data) => ({
        stageByRowId: data.subscriptionData.data.listen.relatedNode
      })
    });
  }

  UNSAFE_componentWillMount() {
    this.subscribeToStage(this.props);
  }

  componentWillUnmount() {
    this.unsubscribeFromStage();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.filtersQuery.filters === this.props.filtersQuery.filters) {
      return;
    }
    if (this.unsubscribeFromStage) {
      this.unsubscribeFromStage();
    }
    this.subscribeToStage(nextProps);
  }

  render = () => {
    const {
      stageQuery: { loading, stageByRowId: stage },
      groupId
    } = this.props;

    if (loading)
      return (
        <TraceIconSpinner
          className="m-auto mt-5 mb-[28px] block size-5 opacity-50"
          small
        />
      );

    return stage.traces.nodes.map(trace => (
      <div className="pb-2" data-cy="atomic-stage-item" key={trace.rowId}>
        <TraceCard groupId={groupId} trace={trace} />
      </div>
    ));
  };
}

export const fragments = {
  stage: gql`
    fragment StageQueryFragment on Stage {
      rowId
      traces(
        # Only get the first 100 traces. This should be paginated at some point.
        first: 100
        filter: {
          or: [
            { rowId: { includesInsensitive: $search } }
            { tags: { contains: [$search] } }
          ]
        }
      ) {
        nodes {
          ...TraceCardFragment
        }
      }
    }
    ${traceCardFragments.trace}
  `
};

export const queries = {
  stageQuery: gql`
    query stageQuery($stageId: BigInt!, $search: String) {
      stageByRowId(rowId: $stageId) {
        ...StageQueryFragment
      }
    }
    ${fragments.stage}
  `
};

export const subscriptions = {
  stage: gql`
    subscription listenStage($id: String!, $search: String) {
      listen(topic: $id) {
        relatedNodeId
        relatedNode {
          ...StageQueryFragment
        }
      }
    }
    ${fragments.stage}
  `
};

export default compose(
  graphql(FILTERS_QUERY, {
    name: 'filtersQuery'
  }),
  graphql(queries.stageQuery, {
    name: 'stageQuery',
    options: ({ stageId }) => ({
      variables: { stageId }
    })
  }),
  withApollo
)(StageTraces);
